import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import './FirstSectionPricing.scss';
import backgroundSvg from '../../../assets/Images/Royalty Management1.svg'; // Ensure this is the correct path to your SVG
import { useNavigate } from 'react-router-dom';
import UnifiedButton from '../../shared/Button';

const FirstSectionPricing = () => {
    const navigate = useNavigate()

    const handleSeeAllPlatformClick = () => {
        navigate('/See-All-Platforms');
    };


    return (
        <Box className="first-section-pricing">
            <Box className="content-wrapper">
                <Typography variant="h2" className="pricing-title">
                    Pricing
                </Typography>
                <Typography variant="body1" className="pricing-description">
                    Get your music on Spotify, Apple Music, TikTok, Amazon, Instagram, Deezer,
                    Tidal, Ganna, JioSaavn, and more. Discover why over one million artists,
                    labels, and music industry leaders trust us globally.
                </Typography>
                <UnifiedButton className="pricing-button" textContent={"See All Platforms"} onClick={handleSeeAllPlatformClick} />


            </Box>
            <img src={backgroundSvg} alt="Background Design" className="background-svg top-left" />
            <img src={backgroundSvg} alt="Background Design" className="background-svg bottom-right" />
        </Box >
    );
};

export default FirstSectionPricing;
